<div>
    <div *ngIf="!loaded">
        <app-spinner></app-spinner>
    </div>
    <div *ngIf="loaded">

        <div us-spinner="{ position: 'relative'}" spinner-key="customerSafetyHistorySpinner"
            spinner-start-active="true">

            <h2 *ngIf="showNoConcernsFound">No Safety Concerns found</h2>
            <!--<table class="table table-striped" ng-show="!vm.showNoConcernsFound && vm.customerSafetyHistory" ng-repeat="safetyconcern in vm.customerSafetyHistory  | orderBy: '-DateReported'">-->

            <h2 *ngIf="showErrorMessage">We cannot find any records at present.</h2>

            <div class="table-responsive">
                <table class="table table-striped" *ngIf="!showNoConcernsFound && customerSafetyHistory">
                    <thead>
                        <tr>
                            <th class="col-xs-1">Unique Reference</th>
                            <th class="col-xs-2">Issue Identified</th>
                            <th class="col-xs-2">Issue Identified Details</th>
                            <th class="col-xs-1">Issue Location</th>
                            <th class="col-xs-2">Property Raised Against</th>
                            <th class="col-xs-2">Location Details</th>
                            <th class="col-xs-1">Reported By</th>
                            <th class="col-xs-1">Status Reason</th>
                            <th class="col-xs-1">Date Raised</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr></tr>
                        <tr *ngFor="let safetyConcern of customerSafetyHistory">

                            <td>{{safetyConcern.uniqueReference}}</td>
                            <td>{{safetyConcern.issueIdentified}}</td>
                            <td>{{safetyConcern.issueIdentifiedDetails}}</td>
                            <td>{{safetyConcern.issueLocation}}</td>
                            <td>{{safetyConcern.propertyRaisedAgainst}}</td>
                            <td>{{safetyConcern.locationDetails}}</td>
                            <td>{{safetyConcern.reportedBy}}</td>
                            <td>{{safetyConcern.statusReason}}</td>
                            <td>{{safetyConcern.dateReported}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>
